// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getWishList } from "@bg/App/Services/WishListService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        props.apiResult = await getWishList(props.parameter);
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({
                type: "Data/WishLists/FailedToLoadWishList",
                wishListId: props.parameter.wishListId,
                status: 404,
            });
            return false;
        }
        throw error;
    }
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
